import { DatePicker } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { useMemo } from "react";

const { RangePicker: RangeAntd } = DatePicker;

const DateRangePicker = (props) => {
  const { t } = useTranslation();

  const ranges = useMemo(() => {
    return [
      {
        label: t("date.yesterday"),
        value: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
      },
      { label: t("date.today"), value: [dayjs(), dayjs()] },
      {
        label: t("date.this_month"),
        value: [dayjs().startOf("month"), dayjs().endOf("month")],
      },
      {
        label: t("date.last_month"),
        value: [
          dayjs().subtract(1, "month").startOf("month"),
          dayjs().subtract(1, "month").endOf("month"),
        ],
      },
      {
        label: t("date.last_7_days"),
        value: [dayjs().subtract(7, "days"), dayjs()],
      },
      {
        label: t("date.last_30_days"),
        value: [dayjs().subtract(30, "days"), dayjs()],
      },
      {
        label: t("date.this_year"),
        value: [dayjs().startOf("year"), dayjs().endOf("year")],
      },
      {
        label: t("date.last_year"),
        value: [
          dayjs().subtract(1, "year").startOf("year"),
          dayjs().subtract(1, "year").endOf("year"),
        ],
      },
    ];
  }, [t]);

  return <RangeAntd format="DD MMMM YYYY" presets={ranges} {...props} />;
};

export default DateRangePicker;
